import { DateTime } from "luxon";
import fetchPonyfill from 'fetch-ponyfill';

const { fetch } = fetchPonyfill({});

const JSON_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

function jsonReplacer(key, value) {
  if (this[key] instanceof Date) {
    return DateTime.fromJSDate(this[key]).toISO();
  }
  return value;
}

async function checkStatus(response) {
  if (!response.ok) {
    if (response.status === 401) {
      window.location.href = "/login";
      return;
    }
    const error = await response.json();
    throw error;
  }
  const contentType = response.headers.get("content-type");

  if (contentType?.includes("application/json")) {
    return await response.json();
  } else if (contentType?.includes("text/plain")) {
    return await response.text();
  } else if (
    contentType?.includes("application/pdf") ||
    contentType?.includes("image") ||
    contentType?.includes("text/csv")
  ) {
    return await response.blob();
  } else {
    return await response.text();
  }
}

export default function useFetch(
  url,
  method,
  body,
  type = "JSON",
  extraHeaders = {},
  extraParams = {}
) {
  if (type === "JSON" && body && typeof body === "string") {
    console.warn(
      "Passer un objet déjà stringifié au body du useFetch n'est pas recommandé car certains objets comme les dates sont nativement mal sérialisées par JavaScript."
    );
  }
  if (method === "GET" && body)
    console.error("Une requête GET ne peut pas contenir de body.");
  return fetch(url, {
    method: method,
    body: type === "JSON" ? JSON.stringify(body, jsonReplacer) : body,
    headers:
      type === "JSON"
        ? { ...JSON_HEADERS, ...extraHeaders }
        : { ...extraHeaders },
    ...extraParams,
  })
    .then(checkStatus)
    .catch((error) => {
      return Promise.reject(error);
    });
}
